<template>
  <div class="aside__submenu-info">
    <div class="aside__submenu-info-inner">
      <p
        v-if="userName"
        class="aside__submenu-info-name"
      >
        {{ userName }}
      </p>
      <p
        v-if="organization"
        class="aside__submenu-info-org"
      >
        {{ organization }}
      </p>
      <p class="aside__submenu-info-status">
        Регистрация как: {{ rolesString }}
      </p>
    </div>
    <button
      class="aside__submenu-btn"
      @click="logout"
    >
      <span class="aside__submenu-btn-span" />
    </button>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { mapState, mapActions } from 'vuex';

export default {
  name: 'UserInfo',
  computed: {
    ...mapState('user', ['roles', 'userData']),
    rolesString() {
      if (Array.isArray(this.roles)) {
        return this.roles.map((role) => role.title).join(', ');
      }
      return '';
    },
    organization() {
      return this.userData.organization?.title || '';
    },
    userName() {
      if (this.userData) {
        const getFirstChar = (word) => {
          if (!word) {
            return '';
          }
          return `${word.toUpperCase().slice(0, 1)}.`;
        };
        const { firstName, lastName, secondName } = this.userData;
        return [lastName, getFirstChar(firstName), getFirstChar(secondName)].join(' ');
      }
      return '';
    },
  },
  methods: {
    ...mapActions({
      logOut: 'user/logOut',
    }),
    async logout() {
      await this.logOut();
    },
  },
};
</script>
